import { COLORS, Text } from "@asayinc/component-library";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface DashboardSummaryItem {
  label: string;
  value: number;
  href: string;
  color?: string;
}

interface DashboardSummaryCardProps {
  title: string;
  items: DashboardSummaryItem[];
}

export function DashboardSummaryCard({
  title,
  items,
}: DashboardSummaryCardProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 2,
        border: `1px solid ${COLORS.P_OUTLINE}`,
        backgroundColor: COLORS.WHITE,
      }}
    >
      <Text variant="subtitle1" sx={{ mb: 3, fontWeight: 600 }}>
        {title}
      </Text>
      <Stack spacing={2}>
        {items.map((item, index) => (
          <Box
            key={index}
            onClick={() => navigate(item.href)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 2,
              px: 3,
              borderRadius: 1,
              border: `1px solid ${COLORS.P_OUTLINE}`,
              cursor: "pointer",
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: item.color || COLORS.SAY_COBALT,
                backgroundColor: `${item.color || COLORS.SAY_COBALT}08`,
              },
            }}
          >
            <Text variant="body2">{item.label}</Text>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Text
                variant="subtitle1"
                sx={{ color: item.color || COLORS.SAY_COBALT, fontWeight: 600 }}
              >
                {item.value}
              </Text>
              <Text variant="body3" sx={{ color: COLORS.P_MED_LOW_EMPHASIS }}>
                events
              </Text>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
